import styled from 'styled-components';
import { deviceBreakpoints } from '../../variables';
import { h2Styles } from 'utils/resuable-css';

export const StepLabelSC = styled.div`
  display: flex;
  align-items: center;
`;

export const StepCount = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  min-width: 200px;
  border: 1px solid ${(props) => props.theme.gray.shade0};
  font-weight: bold;
  font-size: ${(props) => props.theme.default?.h2};
  ${(props) => h2Styles(props.theme.resolutions)};
  line-height: 40px;

  @media only screen and (max-width: ${deviceBreakpoints.tablet}px) {
    padding: 20px 14px;
    min-width: 150px;
  }

  @media only screen and (max-width: ${deviceBreakpoints.sLaptop}px) {
    padding: 20px 12px;
    min-width: 100px;
    line-height: 24px;
  }
`;

export const StepHeading = styled.h2`
  display: inline;
  font-weight: normal;
  line-height: 40px;
  margin: 0;
  margin-left: 15px;
  font-weight: ${(props) => props.headingFontWeight || 'normal'};
  font-size: ${(props) => props.theme.default?.h2};
  ${(props) => h2Styles(props.theme.resolutions)};
  @media only screen and (max-width: ${deviceBreakpoints.phone}px) {
    line-height: 30px;
  }
`;
